export default "__VITE_ASSET__CjjBJDph__"